export default {
  totalPriceAfterBuyback: {
    id: 'checkout_price_title_after_trade_in',
    defaultMessage: 'Total after trade-in',
  },
}
